export const TypesOfProject = {
  _Native: 'Native',
  Cross: 'Cross Platform',
  Low_Code: 'Low Code',
};
